import "./spinner.css";
import Component from "react-pure-render/component";
import React from "react";

export default class Spinner extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="la-ball-clip-rotate-wrapper">
        <div className="la-ball-clip-rotate">
          <div />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/spinner.react.js